import React, { useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { Btn, Modal } from "@/components/ui-kit";
import { Upload, Download, FileSpreadsheet } from "lucide-react";

export default function BulkImportModal({ entity, open, onClose, onImported }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const token = localStorage.getItem("access_token");
      const r = await fetch(`${API_BASE}/import/${entity}`, {
        method: "POST",
        body: fd,
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "Import failed");
      setResult(data);
      if (data.inserted > 0 && onImported) onImported();
    } catch (e) {
      setResult({ inserted: 0, errors: [e.message] });
    } finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title={`Bulk Import ${entity === "doctors" ? "Doctors" : "Pharmacies"}`}>
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3 text-sm text-blue-900">
          1. Download the CSV template<br/>2. Fill in your data<br/>3. Upload the file
        </div>
        <Btn variant="secondary" onClick={() => window.open(`${API_BASE}/import/${entity}/template`)} type="button" data-testid={`download-template-${entity}`}>
          <Download className="w-4 h-4"/> Download Template
        </Btn>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-slate-900 mb-1">CSV File</label>
            <input type="file" accept=".csv" required onChange={(e) => setFile(e.target.files[0])} data-testid={`csv-file-${entity}`}
              className="block w-full text-sm text-slate-700 file:me-3 file:py-2 file:px-4 file:rounded file:border-0 file:bg-blue-50 file:text-blue-700 file:font-semibold hover:file:bg-blue-100"/>
          </div>
          {result && (
            <div className={`p-3 rounded-md text-sm ${result.errors.length === 0 ? "bg-emerald-50 text-emerald-900 border border-emerald-200" : "bg-amber-50 text-amber-900 border border-amber-200"}`}>
              <div className="font-bold">Imported: {result.inserted} rows</div>
              {result.errors.length > 0 && (
                <div className="mt-2 max-h-40 overflow-y-auto text-xs">
                  {result.errors.slice(0, 20).map((er, i) => <div key={i}>· {er}</div>)}
                </div>
              )}
            </div>
          )}
          <div className="flex justify-end gap-2 pt-2 border-t border-slate-200">
            <Btn variant="ghost" type="button" onClick={onClose}>Close</Btn>
            <Btn type="submit" disabled={busy || !file} data-testid={`upload-${entity}`}>
              <Upload className="w-4 h-4"/> {busy ? "Uploading..." : "Upload"}
            </Btn>
          </div>
        </form>
      </div>
    </Modal>
  );
}
